module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-medium-pro-a9c1a8946105633cadf8dbed1412e849.woff2";